import { Dialog } from "@yy/tofu-ui-react";
import React from "react";
import qrImg from "../../images/qrcode.png";
import { useHistory } from "react-router-dom";
import { ModalRoutes } from "./ModalSwitch";

const CertModal = () => {
  const history = useHistory();
  return (
    <Dialog
      title="实名认证"
      active={true}
      cancelTxt="取消"
      showConfirmBtn={false}
      onCancel={() => history.push(ModalRoutes.Root)}
      offsetY={200}
    >
      <div className="cert-dialog-b">
        <div className="left">
          <h4>手机认证</h4>
          <p>
            登录手机YY客户端，进入【个人中心 - 设置- 账号与安全 -
            实名认证】完成认证
          </p>
          <p>推荐使用手机认证，认证更快捷</p>
          <br />
          <h4>
            电脑认证 <span>（需要1-3天）</span>
          </h4>
          <a
            className="tf-ui-link"
            href="https://aq.yy.com/realname/index.do"
            target="_blank"
            rel="noopener noreferrer"
          >
            点击认证 &gt;
          </a>
        </div>
        <div className="right">
          <img src={qrImg} alt="扫描二维码，下载手机YY" />
          <p>扫描二维码，下载手机YY</p>
        </div>
      </div>
    </Dialog>
  );
};

export default CertModal;
